import { withTranslation } from "react-i18next";
import React, { Component } from "react";
import Progress from "../Progress";
import i18next from "i18next";
import Api from "../../../lib/Api";
import MoreInfo from "../../../lib/MoreInfo";

class Gender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      value: props.gender,
      age: props.age,
      redirect: false,
      goBack: false,
    };
    this.getGender = this.getGender.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAge = this.handleChangeAge.bind(this);
    this.handlePropogation = this.handlePropogation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.goBack = this.goBack.bind(this);
    this.skip = this.skip.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.gender,
      age: nextProps.age,
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getGender();
    i18next.on("languageChanged", () => {
      this.getGender();
    });
  }
  render() {
    if (typeof this.state.data.data !== "undefined") {
      var myArr = [];
      for (let v of Object.values(this.state.data.data)) {
        myArr.push([v.id, v.gender, v.image]);
      }
      let handleChange = this.handleChange;
      var gender = this.props.gender;
      if (this.state.value !== undefined) {
        gender = this.state.value;
      }
      var indents = myArr.map(function (item, i) {
        if (i < 2) {
          if (parseInt(gender, 10) === item[0]) {
            return (
              <div
                key={item[0]}
                className={"col-sm-4 option option-" + item[0]}
              >
                <div className="option-inner text-center">
                  <h3>{item[1]}</h3>
                  <img
                    className="img-responsive"
                    src={"/img/" + item[2] + ".png"}
                    alt={item[2]}
                  />
                  <br />
                  <input
                    type="radio"
                    name="gender"
                    checked
                    value={item[0]}
                    onChange={handleChange}
                  />
                </div>
              </div>
            );
          } else {
            return (
              <div
                key={item[0]}
                className={"col-sm-4 option option-" + item[0]}
              >
                <div className="option-inner text-center">
                  <h3>{item[1]}</h3>
                  <img
                    className="img-responsive"
                    src={"/img/" + item[2] + ".png"}
                    alt={item[2]}
                  />
                  <br />
                  <input
                    type="radio"
                    name="gender"
                    value={item[0]}
                    onChange={handleChange}
                  />
                </div>
              </div>
            );
          }
        } else {
          return null;
        }
      });
      return (
        <div className="container main">
          <div className="info-overlay"></div>
          <div className="more-info">
            <i className="closeInfo fas fa-times"></i>
            <div className="more-info-container"></div>
          </div>
          <Progress
            goTo={this.props.goTo}
            step={2}
            traject={this.props.traject}
          />
          <form className="row gender" onSubmit={this.handleSubmit}>
            <div className="col-12 text-center title">
              <h2>{this.props.t("gender_" + this.props.traject)}</h2>
              <span className="sub-title">
                {this.props.t(
                  "Met jouw persoonlijke gegevens kunnen wij je een beter advies geven"
                )}
                .<br />
                {this.props.t(
                  "Wees gerust, wij slaan geen persoonlijke gegevens op"
                )}
                .
              </span>{" "}
              <span
                className="moreInfo link"
                onClick={() => {
                  MoreInfo.show("info", "privacy");
                }}
              >
                <i className="fas fa-caret-right"></i>{" "}
                {this.props.t("Meer informatie")}
              </span>
            </div>
            <div className="col-sm-12 text-center option no-scroll">
              <div className="age">
                <h3>{this.props.t("Leeftijd")}</h3>
                <div className="input-group mb-3">
                  <input
                    id="age"
                    className="form-control"
                    name="age"
                    type="number"
                    value={this.state.age}
                    onChange={this.handleChangeAge}
                    onClick={this.handlePropogation}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" id="basic-addon2">
                      {this.props.t("Jaar")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {indents}
            <div className="col-6 text-left">
              <button
                type="button"
                className="back btn btn-link"
                onClick={this.goBack}
              >
                <i className="fas fa-caret-left"></i>{" "}
                {this.props.t("Terug naar vorige stap")}
              </button>
            </div>
            <div className="col-6 text-right">
              <button
                type="button"
                id="skipbtn"
                className="btn btn-secondary"
                onClick={this.skip}
              >
                {this.props.t("Sla over")}
              </button>
              <input
                id="submitbtn"
                className="btn btn-secondary"
                type="submit"
                value={this.props.t("Volgende")}
              />
            </div>
          </form>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
  getGender() {
    Api.get("/gender").then((response) => {
      this.setState({ data: response.data });
    });
  }
  handleChange(event) {
    this.setState({ value: parseInt(event.target.value, 10) });
    document.getElementById("submitbtn").disabled = false;
  }
  handleChangeAge(e) {
    if (!e) {
      e = window.event;
    }
    e.cancelBubble = true;
    this.setState({ age: e.target.value });
  }
  handlePropogation(e) {
    if (!e) e = window.event;
  }
  handleSubmit(event) {
    event.preventDefault();
    var gender = parseInt(this.state.value, 10);
    this.props.sexHandler(gender === 1 ? 1 : 3);
    this.props.genderHandler(gender);
    this.props.ageHandler(this.state.age).then(() => {
      this.props.goTo("/advice/integration", this.props.traject);
    });
  }
  goBack(event) {
    event.preventDefault();
    this.props.goTo("/advice/image", this.props.traject);
  }
  skip() {
    this.props.sexHandler(3);
    this.props.goTo("/advice/integration", this.props.traject);
  }
}

export default withTranslation("gender")(Gender);
